<div *ngIf="loading$ | async" class="loading-overlay">
  <div class="loading-container">
    <div class="spinner-wrapper">
      <mat-spinner diameter="60" strokeWidth="4"></mat-spinner>
    </div>
    <div class="loading-message">
      {{ message$ | async }}
    </div>
  </div>
</div>
